import React, { useState, useEffect, useCallback } from "react"
import { PrevButton, NextButton } from "../EmblaCarousel/EmblaCarouselButtons"
import useEmblaCarousel from "embla-carousel-react"
import "../EmblaCarousel/embla.css"
import { GatsbyImage } from "gatsby-plugin-image"

const EmblaCarousel = ({ gallery, isModalOpen }) => {
  const options = {
    loop: true,
    align: "start",
    scrollTo: 0,
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(options)
  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false)
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false)

  const scrollPrev = useCallback(
    () => emblaApi && emblaApi.scrollPrev(),
    [emblaApi]
  )
  const scrollNext = useCallback(
    () => emblaApi && emblaApi.scrollNext(),
    [emblaApi]
  )
  const onSelect = useCallback(() => {
    if (!emblaApi) return
    setPrevBtnEnabled(emblaApi.canScrollPrev())
    setNextBtnEnabled(emblaApi.canScrollNext())
  }, [emblaApi])

  useEffect((options) => {
    if (emblaApi) emblaApi.reInit(options)
    if (!emblaApi) return
    emblaApi.on("select", onSelect)
    onSelect()
  }, [emblaApi, onSelect, gallery])

  return (
    <div className={`embla ${gallery.length > 1 ? "mb-32 " : "mb-12"}`}>
      <div
        className="embla__viewport embla__viewport--no-p"
        ref={isModalOpen ? emblaRef : null}
      >
        <div className="embla__container">
          {gallery.map((image, i) => (
            <div className="embla__slide embla__slide--max-two" key={i}>
              <div className=" embla__slide__inner">
                <div className="flex w-full h-[300px]">
                  <GatsbyImage
                    className="object-cover w-full h-full"
                    image={image.gatsbyImageData}
                    alt={
                      image.description
                        ? image.description
                        : "London City Airport"
                    }
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {gallery.length > 1 ? (
        <div
          className={`embla__buttons ${
            gallery.length === 2 ? "embla__buttons--total-two" : ""
          }`}
        >
          <PrevButton
            inverted={true}
            onClick={scrollPrev}
            enabled={prevBtnEnabled}
          />
          <NextButton
            inverted={true}
            onClick={scrollNext}
            enabled={nextBtnEnabled}
          />
        </div>
      ) : null}
    </div>
  )
}

export default EmblaCarousel
